<div class="container">

  <app-header-dialog *ngIf='!_eventService.currentEvent.congress' [iconName]="'star'">
    {{_eventService.localTitle}}
  </app-header-dialog>

  <app-header-dialog *ngIf='_eventService.currentEvent.congress' [iconName]="'local_bar'">
    {{_eventService.localTitle}}
  </app-header-dialog>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !_eventService.spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <div class='bread-crumb' flex>
    <mat-icon color="accent">arrow_right</mat-icon>
    {{ _eventService.breadCrumb(_eventService.localTitle) }}
  </div>

  <mat-tab-group>

    <mat-tab>
      <ng-template *ngIf='!_eventService.currentEvent.congress' mat-tab-label>
        <mat-icon class='tab-icon'>star</mat-icon>
        <div>Evento</div>
      </ng-template>

      <ng-template *ngIf='_eventService.currentEvent.congress' mat-tab-label>
        <mat-icon class='tab-icon'>local_bar</mat-icon>
        <div>Evento</div>
      </ng-template>

      <div class='tab-content-edit' style="padding: 20px 0 0 20px; height: calc(100vh - 205px);">

        <div>
          <mat-form-field class="context-width" appearance="outline">
            <mat-label>Contexto</mat-label>
            <mat-select [errorStateMatcher]="matcher" (ngModelChange)='selecteLocation($event)'
              [errorStateMatcher]="matcher" [formControl]="eventForm.controls.context_id">
              <mat-option *ngFor="let context of contexts" [value]="context.id">
                <span>{{context.name}}</span>
              </mat-option>
            </mat-select>
            <mat-error *ngIf="eventForm.controls.context_id.hasError('required')">
              O Contexto é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-checkbox *ngIf="_eventService.currentEvent.congress && _eventService.currentEvent.master"
            class="master-width" color='primary' [formControl]="eventForm.controls.master">
            Master
          </mat-checkbox>

        </div>

        <mat-form-field class="name_event-width" appearance="outline">
          <mat-label>Nome</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="eventForm.controls.name"
            autocomplete="off">
          <mat-error *ngIf="eventForm.controls.name.hasError('required')">
            O Nome é obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="location-width" appearance="outline">
          <mat-label>Local</mat-label>
          <mat-select [errorStateMatcher]="matcher" (ngModelChange)='selecteLocation($event)'
            [errorStateMatcher]="matcher" [formControl]="eventForm.controls.location_id">
            <mat-option *ngFor="let ccenter of _conventionCenterService.conventionCenters" [value]="ccenter.id">
              <span>{{ccenter.name}}</span>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="eventForm.controls.location_id.hasError('required')">
            O Local é obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="start_day-width" appearance="outline">
          <mat-label>Dt Início</mat-label>
          <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher"
            [formControl]="eventForm.controls.startDay">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="eventForm.controls.startDay.hasError('required')">
            A data de início é obrigatória
          </mat-error>
        </mat-form-field>

        <div>

          <mat-form-field class="key-width" *ngIf="_eventService.currentEvent.master" appearance="outline">
            <mat-label>Chave</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="eventForm.controls.key"
              autocomplete="off">
          </mat-form-field>

        </div>

        <div style="display:flex; flex-direction: row; justify-content: flex-start">

          <div *ngIf="_eventService.currentEvent.belongsToProduct">

            <mat-form-field class="limit-width" appearance="outline">
              <mat-label>Limite por membro</mat-label>
              <input matInput type="number" [errorStateMatcher]="matcher"
                [formControl]="eventForm.controls.limit_per_member" autocomplete="off">
              <mat-error *ngIf="eventForm.controls.limit_per_member.hasError('required')">
                Campo obrigatório
              </mat-error>
            </mat-form-field>

            <mat-checkbox class="ticket-width" color='primary'
              [formControl]="eventForm.controls.control_ticket_by_topic">
              Vagas por tópico
            </mat-checkbox>

          </div>

          <mat-checkbox *ngIf="_eventService.currentEvent.congress" class="prod-width" color='primary'
            [formControl]="eventForm.controls.belongsToProduct">
            Emite certificado, pertence a um produto.
          </mat-checkbox>

        </div>

      </div>

      <div *ngIf='!data.isHistoric' class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button mat-raised-button (click)='insert()' [disabled]="eventForm.invalid" *ngIf="!_eventService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
        <button mat-raised-button (click)='update()' [disabled]="eventForm.invalid" *ngIf="_eventService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </div>

    </mat-tab>

    <mat-tab *ngIf='_eventService.isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>edit_note</mat-icon>
        <div>Texto</div>
      </ng-template>

      <div class='tab-content'>

        <div style="width: 820px; margin-top: 20px;">
          <ckeditor [config]="{ 
                    toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
            [formControl]="eventForm.controls.text" [editor]="Editor"></ckeditor>
          <mat-error *ngIf="eventForm.controls.text.hasError('required')">
            O Texto é obrigatório
          </mat-error>
        </div>

      </div>


      <div *ngIf='!data.isHistoric' class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button mat-raised-button (click)='insert()' [disabled]="eventForm.invalid" *ngIf="!_eventService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
        <button mat-raised-button (click)='update()' [disabled]="eventForm.invalid" *ngIf="_eventService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </div>

    </mat-tab>

    <mat-tab *ngIf='_eventService.isEdit && _eventService.currentEvent.master'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>image_search</mat-icon>
        <div>Imagem</div>
      </ng-template>

      <div class='tab-content-img'>

        <div style="width: 100%; text-align: center;">Programação WEB (1250 x 300 pixels)</div>

        <div class='img-input'>
          <input #file_web type="file" accept='image/png, image/jpg' style='display:none'
            (change)="_eventService.previewImage_web($event)" />
        </div>
        <div class="post-image-web">
          <img [src]="_eventService.storedImage_web" *ngIf="_eventService.storedImage_web">
        </div>
        <div class="button-image">
          <button mat-raised-button (click)='file_web.click()'>
            <mat-icon class='icon-add'>image_search</mat-icon>
          </button>
        </div>

        <div style="width: 100%; text-align: center;">Programação Mobile (1024 x 500 pixels)</div>

        <div class='img-input'>
          <input #file_mobile type="file" accept='image/png, image/jpg' style='display:none'
            (change)="_eventService.previewImage_mobile($event)" />
        </div>
        <div class="post-image-mobile">
          <img [src]="_eventService.storedImage_mobile" *ngIf="_eventService.storedImage_mobile">
        </div>
        <div class="button-image">
          <button mat-raised-button (click)='file_mobile.click()'>
            <mat-icon class='icon-add'>image_search</mat-icon>
          </button>
        </div>

      </div>

      <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button mat-raised-button (click)='updateImages()' *ngIf="_eventService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </div>

    </mat-tab>

    <mat-tab *ngIf='_eventService.isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>brightness_5</mat-icon>
        <div>Dias</div>
      </ng-template>

      <div class='tab-content-day'>

        <mat-table [dataSource]="_dayService.dayDataSource" matSort matSortActive="date" *ngIf="_eventService.isEdit"
          style='height:520px; overflow:auto; margin: 0;'>

          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>brightness_5</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef><span> Dias </span></mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ (element.date.seconds*1000) | date: 'dd/MM/yyyy' }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.name }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openDayDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef>
              <a mat-button (click)="openDayDialog(null)">
                <mat-icon color='primary'>add_circle_outline</mat-icon>
              </a>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='deleteDay(element)' style='background-color: whitesmoke;'>
                <mat-icon class="icon-delete">delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedColumns"></mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedColumns;">
          </mat-row>

        </mat-table>
      </div>

    </mat-tab>

    <mat-tab
      *ngIf='!_eventService.currentEvent.control_ticket_by_topic && _eventService.isEdit && _eventService.currentEvent.belongsToProduct'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>playlist_add</mat-icon>
        <div>Vagas</div>
      </ng-template>


      <div class='tab-content'>

        <div style='width: 100%; height: 20px; line-height: 20px; text-align: center; padding: 5px'>
          <span *ngIf='!eventForm.controls.control_ticket_by_topic.value'>
            Vagas por evento
          </span>
          <span *ngIf='eventForm.controls.control_ticket_by_topic.value'>
            Vagas por tópico
          </span>
        </div>


        <mat-table [dataSource]="_slotService.slotDataSource" style='height:440px; overflow:auto; margin: 0;'>

          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>playlist_add</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.name }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="slot_qtd">
            <mat-header-cell *matHeaderCellDef> Qtd </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.slot_quantity }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="slot_used">
            <mat-header-cell *matHeaderCellDef> Usado</mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.slot_used }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="wait_qtd">
            <mat-header-cell *matHeaderCellDef> Espera </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.slot_wait }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="wait_used">
            <mat-header-cell *matHeaderCellDef> Usado</mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.slot_wait_used }} </mat-cell>
          </ng-container>


          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openSlotDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef>
              <a mat-button (click)='openSlotDialog(null)' *ngIf="!data.isHistoric"
                style='background-color: whitesmoke;'>
                <mat-icon class='icon-add'>
                  info_outline
                </mat-icon>
              </a>

            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button *ngIf="!data.isHistoric" (click)='deleteSlot(element)'
                style='background-color: whitesmoke;'>
                <mat-icon class="icon-delete">delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedSlotsColumns"></mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedSlotsColumns;">
          </mat-row>

        </mat-table>
      </div>


      <!--
      <div *ngIf="!data.isHistoric">
        <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end' *ngIf="_eventService.isEdit">
          <button mat-raised-button (click)='openSlotDialog(null)' [disabled]="eventForm.invalid">
            <mat-icon class='icon-add'>add_circle_outline</mat-icon>
          </button>
        </div>
      </div>
-->

    </mat-tab>

    <mat-tab *ngIf='false'> <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>how_to_reg</mat-icon>
        <div>Frequencia</div>
      </ng-template>

      <div class='tab-content'>

        <mat-table [dataSource]="frequencyDataSource" style='height: 480px; overflow:auto; margin: 0;'>

          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>how_to_reg</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="member">
            <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.member_name }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div>
                {{ element.date | date: 'dd/MM/yyyy HH:mm' }}
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="event">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">

              <ul>
                <li *ngIf='element.day_name'>{{ element.day_name }}</li>
                <li *ngIf='element.activity_name'>{{ element.activity_name }}</li>
                <li *ngIf='element.topic_name'>{{ element.topic_name }}</li>
              </ul>

            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef> Tipo </mat-header-cell>
            <mat-cell *matCellDef="let element">

              <span *ngIf='element.type == "Exit"'>
                <img src='/assets/images/status/img_red.png'>
              </span>

              <span *ngIf='element.type != "Exit"'>
                <img src='/assets/images/status/img_green.png'>
              </span>

            </mat-cell>
          </ng-container>

          <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedFrequencyColumns">
          </mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedFrequencyColumns;">
          </mat-row>

        </mat-table>
      </div>

      <div *ngIf="!data.isHistoric">
        <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end' *ngIf="_eventService.isEdit">
          <button mat-raised-button (click)='exportFrequency()' [disabled]="eventForm.invalid">
            <mat-icon class='icon-add'>arrow_circle_down</mat-icon>
          </button>
        </div>
      </div>

    </mat-tab>

    <mat-tab *ngIf='false'> <!--_eventService.isEdit-->
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>people_outline</mat-icon>
        <div>Certificados</div>
      </ng-template>

      <mat-tab-group>

        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>people_outline</mat-icon>
            <div style='color:rgb(43,54,123)'>Inscritos</div>
          </ng-template>


          <div class='tab-content-cert'>
            <div>

              <button style='width: 240px; margin: 0 0 10px 0;' mat-raised-button (click)="goToLinkDoc('user')">
                Docx Inscritos
              </button>


              <button style='margin-left: 10px;' (click)='file.click()' mat-raised-button>
                <mat-icon class='icon-add'>search</mat-icon>
              </button>

              <input #file type="file" style='display:none;' (change)="_eventService.setDocUsers($event)" />

              <span style='margin-left: 10px;' *ngIf='_eventService.docUsers'>
                selecionado: {{ _eventService.docUsers.name }}
              </span>

              <mat-form-field style='width: 80px; margin-left: 30px;' appearance="outline">
                <mat-label>QRCode Top</mat-label>
                <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="eventForm.controls.docUserTop"
                  autocomplete="off">
              </mat-form-field>
              <mat-form-field style='width: 80px; margin-left: 30px;' appearance="outline">
                <mat-label>QRCode Left</mat-label>
                <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="eventForm.controls.docUserLeft"
                  autocomplete="off">
              </mat-form-field>

              <mat-form-field style='width: 340px; margin-left: 30px;' appearance="outline">
                <mat-label>QRCode URL</mat-label>
                <input matInput type="text" [errorStateMatcher]="matcher"
                  [formControl]="eventForm.controls.urlQRCodeUser" autocomplete="off">
              </mat-form-field>

            </div>

            <mat-table [dataSource]="subscriptionDataSource" style='height: calc(100vh - 320px); overflow:auto;'>

              <ng-container matColumnDef="icon">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>recent_actors</mat-icon>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="product_name">
                <mat-header-cell *matHeaderCellDef> Produto </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.product_name }} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="member_name">
                <mat-header-cell *matHeaderCellDef> Inscrito </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.member_name }} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="selected">
                <mat-header-cell *matHeaderCellDef>
                  <mat-checkbox color='primary' #checkbox (change)='toggleCheckUsers(checkbox.checked)'>
                  </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">

                  <mat-checkbox color='primary' [(ngModel)]="element.selected">
                  </mat-checkbox>

                </mat-cell>
              </ng-container>

              <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedCertificateColumns">
              </mat-header-row>

              <mat-row *matRowDef="let row; columns: displayedCertificateColumns;">
              </mat-row>

            </mat-table>
          </div>

          <div *ngIf="!data.isHistoric">
            <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
              <button mat-raised-button (click)='updateEnrollmentUsers()'>
                <mat-icon class='icon-done'>check_circle_outline</mat-icon>
              </button>
            </div>
          </div>

        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>people</mat-icon>
            <div style='color:rgb(43,54,123)'>Staff</div>
          </ng-template>

          <div class='tab-content-cert'>
            <div>

              <button style='width: 240px; margin: 0 0 10px 0;' mat-raised-button (click)="goToLinkDoc('staff')">
                Docx Staff
              </button>


              <button style='margin-left: 10px;' (click)='fileStaff.click()' mat-raised-button>
                <mat-icon class='icon-add'>search</mat-icon>
              </button>

              <input #fileStaff type="file" style='display:none;' (change)="_eventService.setDocStaff($event)" />

              <span style='margin-left: 10px;' *ngIf='_eventService.docStaff'>
                selecionado: {{ _eventService.docStaff.name }}
              </span>

              <mat-form-field style='width: 80px; margin-left: 30px;' appearance="outline">
                <mat-label>QRCode Top</mat-label>
                <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="eventForm.controls.docStaffTop"
                  autocomplete="off">
              </mat-form-field>
              <mat-form-field style='width: 80px; margin-left: 30px;' appearance="outline">
                <mat-label>QRCode Left</mat-label>
                <input matInput type="text" [errorStateMatcher]="matcher"
                  [formControl]="eventForm.controls.docStaffLeft" autocomplete="off">
              </mat-form-field>

              <mat-form-field style='width: 340px; margin-left: 30px;' appearance="outline">
                <mat-label>QRCode URL</mat-label>
                <input matInput type="text" [errorStateMatcher]="matcher"
                  [formControl]="eventForm.controls.urlQRCodeStaff" autocomplete="off">
              </mat-form-field>

            </div>

            <mat-table [dataSource]="staffDataSource"
              style='height: calc(100vh - 340px);  overflow:auto; margin: 0 0 10px 0;'>

              <ng-container matColumnDef="icon">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>recent_actors</mat-icon>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="member_name">
                <mat-header-cell *matHeaderCellDef> Staff </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.member_name }}
                  <br>
                  {{ element.type }}
                  <br>
                  {{element.certificate_url}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="role_name">
                <mat-header-cell *matHeaderCellDef> Módulo </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div style='display: flex; flex-direction: column;'>
                    <div style='padding: 5px 0 5px 0;'>
                      • {{ element.day_name }}<br>
                      • {{ element.activity_name }}<br>
                      • {{ element.topic_name }}<br>
                    </div>
                    <div *ngIf="element.certificate_url" style='display: flex; flex-direction: row; color: blue;'>

                      <div style='margin-left:50px; padding: 5px;'>
                        <a matTooltip="Visualizar" target='_blank' href={{element.certificate_url}}>
                          <mat-icon>remove_red_eye</mat-icon>
                        </a>
                      </div>

                    </div>
                  </div>
                </mat-cell>
              </ng-container>


              <ng-container matColumnDef="selected">
                <mat-header-cell *matHeaderCellDef>
                  <mat-checkbox color='primary' #checkboxStaff (change)='toggleCheckStaff(checkboxStaff.checked)'>
                  </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">

                  <mat-checkbox color='primary' [(ngModel)]="element.selected">
                  </mat-checkbox>

                </mat-cell>
              </ng-container>

              <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedCertificateStaffColumns">
              </mat-header-row>

              <mat-row *matRowDef="let row; columns: displayedCertificateStaffColumns;">
              </mat-row>

            </mat-table>
          </div>

          <div *ngIf="!data.isHistoric">
            <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
              <button mat-raised-button (click)='updateEnrollmentStaff()'>
                <mat-icon class='icon-done'>check_circle_outline</mat-icon>
              </button>
            </div>
          </div>

        </mat-tab>

      </mat-tab-group>

    </mat-tab>

    <!--
    <mat-tab *ngIf='false'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>email_outline</mat-icon>
        <div>Cartas</div>
      </ng-template>

      <mat-tab-group>

        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>email_outline</mat-icon>
            <div style='color:rgb(43,54,123)'>Cartas Palestrantes</div>
          </ng-template>

          <div class='tab-content-letter'>

            <mat-tab-group>

              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>email_outline</mat-icon>
                  <div style='color:rgb(43,54,123)'>Cartas</div>
                </ng-template>

                <div class='tab-content-email'>

                  <mat-toolbar class="toolbar-top">

                    <div flex justify-content='flex-end' fxLayoutAlign="end">

                      <a mat-button (click)="openLetterDialog(null)" style='width:60px;'>
                        <mat-icon color='primary'>add_circle_outline</mat-icon>
                      </a>

                    </div>

                  </mat-toolbar>

                  <mat-table style='height: calc(100vh - 360px); overflow: auto;'
                    [dataSource]="_letterV2Service.letterDataSource" matSort matSortDisableClear=true>

                    <ng-container matColumnDef="icon">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <mat-icon style='font-size:1.2em; margin-top:10px;'>mail_outline</mat-icon>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="letter-name">
                      <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <div style='display:flex; flex-direction:column;'>
                          <div>{{ element.name }}</div>
                          <div style='font-style: italic;'>
                            <div *ngIf='element.type=="0"'>Confirmação</div>
                            <div *ngIf='element.type=="1"'>Atualização</div>
                          </div>
                        </div>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="preview">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <a mat-button (click)='openPreviewDialog(element)' style='background-color: whitesmoke;'>
                          <mat-icon class='icon-help' style='font-size:1.5em;'>preview
                          </mat-icon>
                        </a>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="edit">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <a mat-button (click)='openLetterDialog(element)' style='background-color: whitesmoke;'>
                          <mat-icon class='icon-info' style='font-size:1.5em;'>
                            info_outline
                          </mat-icon>
                        </a>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <a mat-button (click)='deleteLetter(element)' style='background-color: whitesmoke;'>
                          <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                          </mat-icon>
                        </a>
                      </mat-cell>
                    </ng-container>


                    <mat-header-row *matHeaderRowDef="_letterV2Service.letterDisplayedColumns"></mat-header-row>

                    <mat-row *matRowDef="let row; columns: _letterV2Service.letterDisplayedColumns;"></mat-row>

                  </mat-table>
                </div>

              </mat-tab>

              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>forward_to_inbox</mat-icon>
                  <div style='color:rgb(43,54,123)'>Convites</div>
                </ng-template>

                <div class='tab-content-invite'>

                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Cartas</mat-label>
                    <mat-select (ngModelChange)='letterSelect($event)' [(ngModel)]='letterSelected'>
                      <mat-option *ngFor="let letter of _letterV2Service.letters" [value]="letter">
                        <span>{{ letter.name }}</span>
                        <span> - </span>
                        <span *ngIf="letter.type=='0'"><i>Confirmação</i></span>
                        <span *ngIf="letter.type=='1'"><i>Atualização</i></span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-table style="height: calc(100vh - 420px); overflow: auto;"
                    [dataSource]="_inviteV2Service.invitesDataSource" matSort matSortDisableClear=true>

                    <ng-container matColumnDef="staff_name">
                      <mat-header-cell *matHeaderCellDef>
                        Palestrantes
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">

                        <div *ngIf='element.date_sent' style='padding-top: 10px;'>

                          <a target='_blank' href={{element.url_back}}>
                            <span style="color: black;">
                              {{ element.member_name }}
                            </span>
                          </a>

                          <div style='padding: 5px;'>
                            <span *ngIf="element.admin_invite">
                              <i>Convite via admin</i>
                            </span>
                            <span *ngIf="element.admin_response">
                              - <i>Resposta via admin</i>
                            </span>
                          </div>

                        </div>

                        <div *ngIf='!element.date_sent' style='padding-top: 10px;'>
                          <div>
                            {{ element.member_name }}
                          </div>
                          <div *ngIf='element.obs' style='padding: 10px 5px 0px 5px; margin-left: 60px;'>
                            Obs: {{element.obs}}
                          </div>
                        </div>

                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="confirm">
                      <mat-header-cell *matHeaderCellDef>
                        Confirmar
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <span *ngIf="element.requireConfirmAll" style="color: green;">(Confirmar)</span>
                        <span *ngIf="!element.requireConfirmAll" style="color: red;">(Não confirmar)</span>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="date_sent">
                      <mat-header-cell *matHeaderCellDef>
                        Envio
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <div>
                          <div *ngIf='element.date_sent'>
                            {{ element.date_sent | date: 'dd/MM/yyyy' }}
                          </div>
                        </div>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="date_response">
                      <mat-header-cell *matHeaderCellDef>
                        Resposta
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <div>
                          <div *ngIf='element.date_response'>
                            {{ element.date_response | date: 'dd/MM/yyyy' }}
                          </div>
                        </div>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="accept">
                      <mat-header-cell *matHeaderCellDef>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">

                        <div *ngIf='!element.accept && element.date_response'
                          style='background-color: red; width:10px; height: 10px; border-radius: 50%;'>
                        </div>

                        <div *ngIf='element.accept && element.date_response'
                          style='background-color: rgb(46, 194, 46); width:10px; height: 10px; border-radius: 50%;'>
                        </div>

                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">

                        <a *ngIf='element.date_sent' mat-button (click)='deleteInvite(element)'
                          style='background-color: whitesmoke;'>
                          <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                          </mat-icon>
                        </a>

                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="select">

                      <mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)='changeAllLetters($event)' color='primary'></mat-checkbox>
                      </mat-header-cell>

                      <mat-cell *matCellDef="let element">
                        <div *ngIf='!element.date_sent'>
                          <mat-checkbox color='primary' [(ngModel)]="element.selected"></mat-checkbox>
                        </div>
                      </mat-cell>

                    </ng-container>

                    <ng-container matColumnDef="edit">
                      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <a mat-button (click)='openInviteDialog(element)' style='background-color: whitesmoke;'>
                          <mat-icon class='icon-info' style='font-size:1.5em;'>
                            info_outline
                          </mat-icon>
                        </a>
                      </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="_inviteV2Service.invitesDisplayColumns"></mat-header-row>

                    <mat-row *matRowDef="let row; columns: _inviteV2Service.invitesDisplayColumns;"></mat-row>

                  </mat-table>

                </div>

                <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
                  <button mat-raised-button (click)='makeShipping()'>
                    <mat-icon class='icon-done'>check_circle_outline</mat-icon>
                  </button>
                </div>

              </mat-tab>

              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>mark_email_read</mat-icon>
                  <div style='color:rgb(43,54,123)'>Respostas</div>
                </ng-template>

                <div class='tab-content-cert'>

                  <mat-table style='height: calc(100vh - 280px); overflow: auto;'
                    [dataSource]="_inviteV2Service.responsesDataSource" matSort matSortDisableClear='true'>

                    <ng-container matColumnDef="member_name_response">
                      <mat-header-cell *matHeaderCellDef>
                        Palestrantes & Palestras
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">

                        <div class='letter'>

                          <div style='padding: 5px 5px 5px 0;'>
                            <div>
                              <a mat-button (click)="openMemberDataDialog(element)" style="color:rgba(0,0,0,.6);">
                                <b>
                                  {{ element.name }}
                                </b>
                              </a>
                            </div>

                          </div>

                          <ul *ngFor="let letter of element.letters" style="margin-left:20px;">
                            <li>
                              <div
                                style="width: 100%; display:flex; flex-direction: row; justify-content: space-between;">
                                <div>
                                  <span>{{letter.letter_name}}</span>
                                  <span style='color:rgba(0,0,0,.7);' *ngIf='letter.type=="0"'> - Confirmação</span>
                                  <span style='color:rgba(0,0,0,.7);' *ngIf='letter.type=="1"'> - Atualização</span>

                                  <div *ngIf='letter.obs' style='padding:5px;'>
                                    OBS: {{letter.obs}}
                                  </div>
                                  <div *ngIf='letter.date_sent'>
                                    <div style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                                      Enviado: {{letter.date_sent.seconds*1000 | date: 'dd/MM/yyyy'}}
                                    </div>
                                  </div>
                                  <div *ngIf='letter.date_response'>
                                    <div *ngIf='!letter.accept && letter.date_response'
                                      style='padding: 0 10px 0 10px; margin: 5px; width: 160px;'>
                                      <img src='assets/images/status/img_red.png'>
                                      Resposta: {{letter.date_response.seconds*1000 | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf='letter.accept && letter.date_response'
                                      style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                                      <img src='assets/images/status/img_green.png'>
                                      Resposta: {{letter.date_response.seconds*1000 | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf='letter.accept && letter.date_response && letter.publishSlides'
                                      style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                                      <img src='assets/images/status/img_green.png'>
                                      Publicar slides.
                                    </div>
                                    <div *ngIf='letter.accept && letter.date_response && !letter.publishSlides'
                                      style='padding: 0 10px 0 10px;  margin: 5px; width: 260px;'>
                                      <img src='assets/images/status/img_red.png'>
                                      Não publicar slides.
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <a mat-button (click)='archiveItem(letter)' style='background-color: whitesmoke;'>
                                    <mat-icon style='font-size:1.5em; color:orange'>
                                      info_outline
                                    </mat-icon>
                                  </a>
                                </div>
                              </div>
                            </li>
                          </ul>

                        </div>
                      </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="_inviteV2Service.reponsesDisplayColumns"></mat-header-row>

                    <mat-row *matRowDef="let row; columns: _inviteV2Service.reponsesDisplayColumns;"></mat-row>

                  </mat-table>

                </div>

              </mat-tab>

              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>insert_drive_file</mat-icon>
                  <div style='color:rgb(43,54,123)'>Arquivo</div>
                </ng-template>


                <div class='tab-content-cert'>

                  <mat-table style='height: calc(100vh - 280px); overflow: auto;'
                    [dataSource]="_inviteV2Service.responsesArchivedDataSource" matSort matSortDisableClear='true'>

                    <ng-container matColumnDef="member_name_response">
                      <mat-header-cell *matHeaderCellDef>
                        Palestrantes & Palestras
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">

                        <div class='letter'>

                          <div style='padding: 5px 5px 5px 0;'>
                            <div>
                              <a mat-button (click)="openMemberDataDialog(element)" style="color:rgba(0,0,0,.6);">
                                <b>
                                  {{ element.name }}
                                </b>
                              </a>
                            </div>

                          </div>

                          <ul *ngFor="let letter of element.letters" style="margin-left:20px;">
                            <li>
                              <div
                                style="width: 100%; display:flex; flex-direction: row; justify-content: space-between;">
                                <div>
                                  <span>{{letter.letter_name}}</span>
                                  <span style='color:rgba(0,0,0,.7);' *ngIf='letter.type=="0"'> - Confirmação</span>
                                  <span style='color:rgba(0,0,0,.7);' *ngIf='letter.type=="1"'> - Atualização</span>

                                  <div *ngIf='letter.obs' style='padding:5px;'>
                                    OBS: {{letter.obs}}
                                  </div>
                                  <div *ngIf='letter.date_sent'>
                                    <div style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                                      Enviado: {{letter.date_sent.seconds*1000 | date: 'dd/MM/yyyy'}}
                                    </div>
                                  </div>
                                  <div *ngIf='letter.date_response'>
                                    <div *ngIf='!letter.accept && letter.date_response'
                                      style='padding: 0 10px 0 10px; margin: 5px; width: 160px;'>
                                      <img src='assets/images/status/img_red.png'>
                                      Resposta: {{letter.date_response.seconds*1000 | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf='letter.accept && letter.date_response'
                                      style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                                      <img src='assets/images/status/img_green.png'>
                                      Resposta: {{letter.date_response.seconds*1000 | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf='letter.accept && letter.date_response && letter.publishSlides'
                                      style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                                      <img src='assets/images/status/img_green.png'>
                                      Publicar slides.
                                    </div>
                                    <div *ngIf='letter.accept && letter.date_response && !letter.publishSlides'
                                      style='padding: 0 10px 0 10px;  margin: 5px; width: 260px;'>
                                      <img src='assets/images/status/img_red.png'>
                                      Não publicar slides.
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <a mat-button (click)='archiveItem(letter)' style='background-color: whitesmoke;'>
                                    <mat-icon style='font-size:1.5em; color:orange'>
                                      info_outline
                                    </mat-icon>
                                  </a>
                                </div>
                              </div>
                            </li>
                          </ul>

                        </div>
                      </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="_inviteV2Service.reponsesDisplayColumns"></mat-header-row>

                    <mat-row *matRowDef="let row; columns: _inviteV2Service.reponsesDisplayColumns;"></mat-row>

                  </mat-table>

                </div>

              </mat-tab>

            </mat-tab-group>

          </div>

        </mat-tab>

      </mat-tab-group>

    </mat-tab>
  -->
  </mat-tab-group>

</div>